// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-page-portfolio-portfolio-detail-tab-documents-table-EmptyTableSection-module__root--2PPjd"};